export const FETCH_STOCK_RETURNS_REQUEST = 'FETCH_STOCK_RETURNS_REQUEST';
export const FETCH_STOCK_RETURNS_SUCCESS = 'FETCH_STOCK_RETURNS_SUCCESS';
export const FETCH_STOCK_RETURNS_FAILURE = 'FETCH_STOCK_RETURNS_FAILURE';

export const CREATE_STOCK_RETURN_REQUEST = 'CREATE_STOCK_RETURN_REQUEST';
export const CREATE_STOCK_RETURN_SUCCESS = 'CREATE_STOCK_RETURN_SUCCESS';
export const CREATE_STOCK_RETURN_FAILURE = 'CREATE_STOCK_RETURN_FAILURE';

export const UPDATE_STOCK_RETURN_REQUEST = 'UPDATE_STOCK_RETURN_REQUEST';
export const UPDATE_STOCK_RETURN_SUCCESS = 'UPDATE_STOCK_RETURN_SUCCESS';
export const UPDATE_STOCK_RETURN_FAILURE = 'UPDATE_STOCK_RETURN_FAILURE';

export const PROCESS_STOCK_RETURN_REQUEST = 'PROCESS_STOCK_RETURN_REQUEST';
export const PROCESS_STOCK_RETURN_SUCCESS = 'PROCESS_STOCK_RETURN_SUCCESS';
export const PROCESS_STOCK_RETURN_FAILURE = 'PROCESS_STOCK_RETURN_FAILURE';

export const DELETE_STOCK_RETURN_REQUEST = 'DELETE_STOCK_RETURN_REQUEST';
export const DELETE_STOCK_RETURN_SUCCESS = 'DELETE_STOCK_RETURN_SUCCESS';
export const DELETE_STOCK_RETURN_FAILURE = 'DELETE_STOCK_RETURN_FAILURE'; 